export const APPLY_TO_JOB_OFFER_REQUEST = 'APPLY_TO_JOB_OFFER_REQUEST';
